import { Heading, Subheading } from "../../../../../design/heading";
import { Divider } from "../../../../../design/divider";
import { useIntegration } from "../../../../../contexts/IntegrationContext";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

export default function IntegrationCallbackPage() {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  const state = urlParams.get("state");
  const error = urlParams.get("error");
  const { updateIntegration } = useIntegration();
  const { integrationId } = useParams<{ integrationId: string }>();

  useEffect(() => {
    switch (integrationId) {
      case "clio":
        if (code) {
          const integrateClio = async () => {
            await updateIntegration(integrationId, {
              code,
            });
          };
          integrateClio()
            .then(() => {
              window.location.href = "/settings/integrations";
            })
            .catch((error) => {
              console.error("Error integrating Clio:", error);
              alert("Failed to integrate Clio. Please try again.");
            });
        }
        break;
      default:
        console.error("Unknown integration:", integrationId);
        alert("Unknown integration. Please try again.");
        break;
    }
  }, [code, state, error]);
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Settings", href: "/settings" },
          { label: "Integrations", href: "/settings/integrations" },
        ]}
      />
      <div className="flex items-center gap-4">
        <Heading>Integration Callback</Heading>
        <Subheading>Sync your data with third-party applications</Subheading>
      </div>
    </div>
  );
}
